<app-header [darkMode]="darkMode$ | async" [scrollArea]="scrollArea" [startAbove]="100" [backDefault]="undefined">
</app-header>

<ion-content #scrollArea scrollEvents="true" fullscreen="true">
  <div class="main-wrapper">
    <app-section-hero-static [darkMode]="darkMode$ | async" [scrollToId]="(firstSectionId$ | async)"
      [contactAvailable]="contactAvailable$ | async" (scrollToElement)="scrollToElement($event)">
    </app-section-hero-static>
    <div class="marker-div" #heroMarker></div>

    <app-loader [loading$]="loading$" [overlay]="'no'"></app-loader>

    <app-section *ngFor="let section of (sections$ | async); trackBy:sectionById;" [data]="section"
      [index]="section.title_index" [darkMode]="darkMode$ | async" [locale]="currentLanguage$ | async">
    </app-section>

    <app-footer></app-footer>
  </div>
</ion-content>